import { AxiosError } from 'axios';
import { createAsyncAction } from 'typesafe-actions';
import { Expense, ExpenseParams } from './types';

export const GET_EXPENSE_LIST = 'expenses/GET_EXPENSE_LIST';
export const GET_EXPENSE_LIST_SUCCESS = 'expenses/GET_EXPENSE_LIST_SUCCESS';
export const GET_EXPENSE_LIST_ERROR = 'expenses/GET_EXPENSE_LIST_ERROR';

export const UPDATE_EXPENSE = 'expenses/UPDATE_EXPENSE';
export const UPDATE_EXPENSE_SUCCESS = 'expenses/UPDATE_EXPENSE_SUCCESS';
export const UPDATE_EXPENSE_ERROR = 'expenses/UPDATE_EXPENSE_ERROR';

export const DELETE_EXPENSE = 'expenses/DELETE_EXPENSE';
export const DELETE_EXPENSE_SUCCESS = 'expenses/DELETE_EXPENSE_SUCCESS';
export const DELETE_EXPENSE_ERROR = 'expenses/DELETE_EXPENSE_ERROR';

export const GET_EXPENSE_DETAIL = 'expenses/GET_EXPENSE_DETAIL';
export const GET_EXPENSE_DETAIL_SUCCESS = 'expenses/GET_EXPENSE_DETAIL_SUCCESS';
export const GET_EXPENSE_DETAIL_ERROR = 'expenses/GET_EXPENSE_DETAIL_ERROR';

export const CREATE_EXPENSE = 'expenses/CREATE_EXPENSE';
export const CREATE_EXPENSE_SUCCESS = 'expenses/CREATE_EXPENSE_SUCCESS';
export const CREATE_EXPENSE_ERROR = 'expenses/CREATE_EXPENSE_ERROR';

export const CREATE_EXPENSE_EVALUATION = 'expenses/CREATE_EXPENSE_EVALUATION';
export const CREATE_EXPENSE_EVALUATION_SUCCESS =
  'expenses/CREATE_EXPENSE_EVALUATION_SUCCESS';
export const CREATE_EXPENSE_EVALUATION_ERROR =
  'expenses/CREATE_EXPENSE_EVALUATION_ERROR';

export const DELETE_EXPENSE_EVALUATION = 'expenses/DELETE_EXPENSE_EVALUATION';
export const DELETE_EXPENSE_EVALUATION_SUCCESS =
  'expenses/DELETE_EXPENSE_EVALUATION_SUCCESS';
export const DELETE_EXPENSE_EVALUATION_ERROR =
  'expenses/DELETE_EXPENSE_EVALUATION_ERROR';

export const CREATE_EXPENSE_COMMENT = 'expenses/CREATE_EXPENSE_COMMENT';
export const CREATE_EXPENSE_COMMENT_SUCCESS =
  'expenses/CREATE_EXPENSE_COMMENT_SUCCESS';
export const CREATE_EXPENSE_COMMENT_ERROR =
  'expenses/CREATE_EXPENSE_COMMENT_ERROR';

export const GET_MY_EXPENSE_LIST = 'expenses/GET_MY_EXPENSE_LIST';
export const GET_MY_EXPENSE_LIST_SUCCESS =
  'expenses/GET_MY_EXPENSE_LIST_SUCCESS';
export const GET_MY_EXPENSE_LIST_ERROR = 'expenses/GET_MY_EXPENSE_LIST_ERROR';

export const getExpenseListAsync = createAsyncAction(
  GET_EXPENSE_LIST,
  GET_EXPENSE_LIST_SUCCESS,
  GET_EXPENSE_LIST_ERROR,
)<ExpenseParams, Expense[], AxiosError>();

export const updateExpenseAsync = createAsyncAction(
  UPDATE_EXPENSE,
  UPDATE_EXPENSE_SUCCESS,
  UPDATE_EXPENSE_ERROR,
)<ExpenseParams, Expense, AxiosError>();

export const deleteExpenseAsync = createAsyncAction(
  DELETE_EXPENSE,
  DELETE_EXPENSE_SUCCESS,
  DELETE_EXPENSE_ERROR,
)<ExpenseParams, any, AxiosError>();

export const getExpenseDetailAsync = createAsyncAction(
  GET_EXPENSE_DETAIL,
  GET_EXPENSE_DETAIL_SUCCESS,
  GET_EXPENSE_DETAIL_ERROR,
)<ExpenseParams, Expense, AxiosError>();

export const createExpenseAsync = createAsyncAction(
  CREATE_EXPENSE,
  CREATE_EXPENSE_SUCCESS,
  CREATE_EXPENSE_ERROR,
)<ExpenseParams, Expense, AxiosError>();

export const createExpenseCommentAsync = createAsyncAction(
  CREATE_EXPENSE_COMMENT,
  CREATE_EXPENSE_COMMENT_SUCCESS,
  CREATE_EXPENSE_COMMENT_ERROR,
)<any, Expense, AxiosError>();

export const getMyExpenseListAsync = createAsyncAction(
  GET_MY_EXPENSE_LIST,
  GET_MY_EXPENSE_LIST_SUCCESS,
  GET_MY_EXPENSE_LIST_ERROR,
)<ExpenseParams, Expense[], AxiosError>();
